// extracted by mini-css-extract-plugin
module.exports = {"table":"table_table__jqKvL","compact":"table_compact__5CNYA","spacious":"table_spacious__1enMO"};